/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { API_CONFIG, getApiUrl } from "@/config/apiConfig";
import { getAuthHeaders } from "./authApi";
import { handleResponse } from "./apiHandler";

export const getUserDetails = async (id: string) => {
  const endpoint = API_CONFIG.endpoints.user.profileDetails.replace(":id", id);
  const url = getApiUrl(endpoint);

  const response = await fetch(url, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  return await handleResponse(response, "Fetch User Details");
};

export const updateUser = async (id: string, payload: any, file?: File) => {
  const endpoint = API_CONFIG.endpoints.user.updateProfile.replace(":id", id);
  const url = getApiUrl(endpoint);

  let options: any = {
    method: "PUT",
    headers: getAuthHeaders(),
  };

  if (file) {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] !== undefined && payload[key] !== null) {
        formData.append(key, payload[key]);
      }
    });
    formData.append("profile_image", file);
    options.body = formData;
    delete options.headers["Content-Type"];
  } else {
    options.body = JSON.stringify(payload);
  }

  const response = await fetch(url, options);
  return await handleResponse(response, "Update User");
};

export const changeUserPassword = async (
  id: string,
  payload: {
    old_password: string;
    new_password: string;
  },
) => {
  const endpoint = API_CONFIG.endpoints.user.changePassword.replace(":id", id);
  const url = getApiUrl(endpoint);

  const response = await fetch(url, {
    method: "PUT",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  return await handleResponse(response, "Change Password");
};

export const sendVeirfyEmail = async (payload: { email: string }) => {
  const url = getApiUrl(API_CONFIG.endpoints.user.sendVerifyEmail);

  const response = await fetch(url, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  return await handleResponse(response, "Send Verify Email");
};

export const enableMfa = async (otp: string) => {
  const response = await fetch(getApiUrl(API_CONFIG.endpoints.auth.enableMfa), {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ otp }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to enable MFA");
  }

  return data;
};


export const generateMfaSetup = async () => {
  const response = await fetch(
    getApiUrl(API_CONFIG.endpoints.auth.generateMfa),
    {
      method: "POST",
      headers: getAuthHeaders(),
    },
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to generate MFA setup");
  }

  return data;
};

export const disableMfa = async () => {
  const response = await fetch(
    getApiUrl(API_CONFIG.endpoints.auth.disableMfa),
    {
      method: "POST",
      headers: getAuthHeaders(),
    },
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to disable MFA");
  }

  return data;
};
